import { Action } from "@ngrx/store";
import { IConnection } from "src/app/models/connection";

export enum EConnectionAction {
  Online = "[Online]",
}

export class Online implements Action {
  public readonly type = EConnectionAction.Online;
  constructor(public payload: IConnection) {}
}

export type ConnectionAction = Online;
